import { defineMessages } from 'react-intl';
export default defineMessages({
    // Weather Underground
    wundergroundKey: {
        id: 'providerHints.wundergroundKey',
        defaultMessage: 'A long string from your Weather Underground member API keys page — not your wunderground.com password.'
    },
    wundergroundKeyExample: {
        id: 'providerHints.wundergroundKeyExample',
        defaultMessage: 'e.g. 5f6a7b8c9dabcdef…'
    },
    wundergroundStationIdExample: {
        id: 'providerHints.wundergroundStationIdExample',
        defaultMessage: 'e.g. KCASANFR123'
    },
    wundergroundKeyVerified: {
        id: 'providerHints.wundergroundKeyVerified',
        defaultMessage: 'API key verified'
    },
    wundergroundEditKey: {
        id: 'providerHints.wundergroundEditKey',
        defaultMessage: 'Use a different key'
    },
    wundergroundNoStationsNearby: {
        id: 'providerHints.wundergroundNoStationsNearby',
        defaultMessage: 'No stations found near this location. Try entering a station ID directly.'
    },
    // Ecowitt
    ecowittApi: {
        id: 'providerHints.ecowittApi',
        defaultMessage: 'From your Ecowitt account API page.'
    },
    ecowittApp: {
        id: 'providerHints.ecowittApp',
        defaultMessage: 'The Application key, also from your Ecowitt account.'
    },
    // Ambient Weather
    ambientWeatherApiKey: {
        id: 'providerHints.ambientWeatherApiKey',
        defaultMessage: 'Created in your ambientweather.net account settings.'
    },
    // Davis
    davisV2ApiKey: {
        id: 'providerHints.davisV2ApiKey',
        defaultMessage: 'From your weatherlink.com V2 API keys page.'
    },
    davisApiSecret: {
        id: 'providerHints.davisApiSecret',
        defaultMessage: 'Shown only once when you created the V2 API key — keep it safe.'
    },
    // Weatherflow / Tempest
    weatherflowToken: {
        id: 'providerHints.weatherflowToken',
        defaultMessage: 'Personal-use token from tempestwx.com → settings → data authorizations.'
    },
    // My AcuRite — the only provider that takes email/password, so make
    // the framing extra clear.
    myAcuriteEmail: {
        id: 'providerHints.myAcuriteEmail',
        defaultMessage: 'Your My AcuRite account email — not your SmartMixin login.'
    },
    myAcuritePassword: {
        id: 'providerHints.myAcuritePassword',
        defaultMessage: 'Your My AcuRite account password.'
    },
    myAcuriteCredentialsBanner: {
        id: 'providerHints.myAcuriteCredentialsBanner',
        defaultMessage: 'Use your My AcuRite account email and password — not your SmartMixin login.'
    }
});
